export enum PmsProductWantRequestStatus {
  PENDING_FOLLOWUP = 'PENDING_FOLLOWUP',
  RECOMMENDED = 'RECOMMENDED',
  DEAL_CLOSED = 'DEAL_CLOSED',
  CANCELLED = 'CANCELLED',
}

export enum PmsProductWantRequestSource {
  ADMIN = 'ADMIN',
  APP = 'APP',
  WEBSITE = 'WEBSITE',
}

export enum PmsProductWantRequestOperatorType {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
}

export enum PmsProductWantRequestOperateType {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  CANCEL = 'CANCEL',
  DELETE = 'DELETE',
  SEND_EMAIL = 'SEND_EMAIL',
}

export type PmsProductWantRequestMember = {
  id: number;
  email: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
} | null;

/** 编辑抽屉会员 Select 所需字段 */
export type PmsProductWantRequestMemberOption = {
  id: number;
  email: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  showName?: string;
};

export type PmsProductWantRequestRecord = {
  id: number;
  memberId: number | null;
  email: string;
  phone: string | null;
  productCategoryId: number;
  ranks: string[] | null;
  color: string[] | null;
  hardware: string[] | null;
  stamp: string[] | null;
  materials: string[] | null;
  remark: string | null;
  status: PmsProductWantRequestStatus;
  source: PmsProductWantRequestSource;
  deleteStatus: number;
  cancelledAt: string | null;
  cancelReason: string | null;
  createdBy: string | null;
  updatedBy: string | null;
  createTime: string;
  updateTime: string | null;
  member?: PmsProductWantRequestMember;
};

export type PmsProductWantRequestSaveDto = {
  memberId?: number;
  email?: string;
  phone?: string;
  productCategoryId: number;
  ranks?: string[];
  color?: string[];
  hardware?: string[];
  stamp?: string[];
  materials?: string[];
  remark?: string;
  status?: PmsProductWantRequestStatus;
};

export type PmsProductWantRequestListQuery = {
  email?: string;
  phone?: string;
  memberId?: number;
  productCategoryId?: number;
  ranks?: string[];
  color?: string[];
  hardware?: string[];
  stamp?: string[];
  materials?: string[];
  remark?: string;
  status?: PmsProductWantRequestStatus;
  source?: PmsProductWantRequestSource;
  pageNum: number;
  pageSize: number;
};

export type PmsProductWantRequestMatchDetails = {
  categoryMatched: boolean;
  rankMatched: boolean;
  colorMatched: boolean;
  matchedColors: string[];
  hardwareMatched: boolean;
  matchedHardware: string[];
  stampMatched: boolean;
  matchedStamps: string[];
  materialMatchedCount: number;
  matchedMaterials: string[];
};

export type PmsProductWantRequestMatchItem = {
  productId: number;
  matchScore: number;
  matchDetails: PmsProductWantRequestMatchDetails;
  emailEligible: boolean;
  product: {
    id: number;
    name: string;
    pic: string;
    rank: string;
    color?: string;
    hardware?: string;
    stamp?: string;
    material: string;
    stockStatus: string;
    publishStatus: number;
    price: number;
    productCategoryId: number;
    productSn: string;
  };
};

export type PmsProductWantRequestFormValues = {
  memberId?: number;
  email?: string;
  phone?: string;
  productCategoryIdList: number[];
  ranks?: string[];
  color?: string[];
  hardware?: string[];
  stamp?: string[];
  materialPaths?: (string | number)[][];
  remark?: string;
  status?: PmsProductWantRequestStatus;
};

export type PmsProductWantRequestOperateLog = {
  id: number;
  wantRequestId: number;
  operateType: PmsProductWantRequestOperateType;
  operatorType: PmsProductWantRequestOperatorType | null;
  operator: string | null;
  fromStatus: PmsProductWantRequestStatus | null;
  toStatus: PmsProductWantRequestStatus | null;
  remark: string | null;
  createTime: string;
};
